import {MercatorCoordinate} from 'maplibre-gl'

export const DEFAULT_PITCH_AT_MAX_ZOOM = 60
export const MIN_PITCH_ZOOM = 5
export const MAX_PITCH_ZOOM = 17

export const getPitch = (zoom: number): number => {
  if (zoom >= MAX_PITCH_ZOOM) return DEFAULT_PITCH_AT_MAX_ZOOM
  if (zoom <= MIN_PITCH_ZOOM) return 0
  const zoomRange = MAX_PITCH_ZOOM - MIN_PITCH_ZOOM
  const pitchRange = DEFAULT_PITCH_AT_MAX_ZOOM - 0
  const zoomProgress = (zoom - MIN_PITCH_ZOOM) / zoomRange
  return pitchRange * zoomProgress
}

export const calculateGeographicCenter = (
  coordinates: [number, number][]
): [number, number] | null => {
  if (!coordinates || coordinates.length === 0) return null

  const coords = [...coordinates]
  if (
    coords.length > 1 &&
    coords[0][0] === coords[coords.length - 1][0] &&
    coords[0][1] === coords[coords.length - 1][1]
  ) {
    coords.pop()
  }

  const sum = coords.reduce(
    (acc, [lon, lat]) => {
      const lonRad = (lon * Math.PI) / 180
      const latRad = (lat * Math.PI) / 180
      acc.x += Math.cos(latRad) * Math.cos(lonRad)
      acc.y += Math.cos(latRad) * Math.sin(lonRad)
      acc.z += Math.sin(latRad)
      return acc
    },
    {x: 0, y: 0, z: 0}
  )

  const avgX = sum.x / coords.length
  const avgY = sum.y / coords.length
  const avgZ = sum.z / coords.length

  const centerLon = (Math.atan2(avgY, avgX) * 180) / Math.PI
  const hyp = Math.sqrt(avgX * avgX + avgY * avgY)
  const centerLat = (Math.atan2(avgZ, hyp) * 180) / Math.PI

  return [centerLon, centerLat]
}

export const metersBetweenMercator = (
  fromMercator: MercatorCoordinate,
  toMercator: MercatorCoordinate
): {dEastMeter: number; dNorthMeter: number} => {
  const mercatorPerMeter = fromMercator.meterInMercatorCoordinateUnits()
  const dEast = toMercator.x - fromMercator.x
  const dEastMeter = dEast / mercatorPerMeter
  const dNorth = fromMercator.y - toMercator.y
  const dNorthMeter = dNorth / mercatorPerMeter
  return {dEastMeter, dNorthMeter}
}

